// extracted by mini-css-extract-plugin
export var addButton = "_i0-0";
export var border = "_i0-8";
export var check = "_i0-h";
export var danger = "_i0-6";
export var dropdownContainer = "_i0-1";
export var editModalBody = "_i0-j";
export var footerContainer = "_i0-i";
export var fullWidth = "_i0-a";
export var hide = "_i0-9";
export var icon = "_i0-3";
export var input = "_i0-7";
export var inputFlex = "_i0-b";
export var inputWrapper = "_i0-c";
export var manualFocus = "_i0-5";
export var optionButton = "_i0-4";
export var pillWrapper = "_i0-e";
export var pointer = "_i0-2";
export var showOverflow = "_i0-f";
export var tagsFlex = "_i0-d";
export var xButton = "_i0-g";